/* osc-inline-bundle — arm B inline bundle picker for the legacy per-size
 * PDPs (1800 Series / Temp-Neutral). v3: two percent-ladder rung cards
 * ("2 sets" / "4 sets") that expand an inline mix & match panel — priced
 * live from each product's bundle:v3b: tag via window.OSCV3B, the SAME math
 * the checkout Function applies (bundle-core.computeV3bDiscount), so the
 * preview always matches checkout. All sets are PAID lines; nothing is free.
 *
 * These lines are one product per size, so a slot's size <select> switches
 * products; each size carries its own v3b tags (CFG.v3bBySize) and the group
 * discount lands on the cheaper units, exactly like the Function.
 *
 * A product with no v3b tag renders no rungs (singles only). Rungs whose
 * increment fails the $25 clamp are hidden. The old BXGY free-set path is
 * retired — never stamped, never shown.
 */
(function () {
  "use strict";
  function boot() {
    var root = document.querySelector("[data-oib]");
    if (!root || root.__oibBooted) return;
    root.__oibBooted = true;
    // RETIRED (v3.1): to keep the A/B arms structurally identical, arm B now
    // shows the same static offer box as arm A (rendered by productFunctions'
    // displayBundleDetails with v3b totals) instead of this interactive
    // picker. Shoppers bundle via the quantity selector, exactly like arm A;
    // the checkout Function prices it. Kept in place for easy rollback.
    root.style.display = "none";
    return;
    if (window.OSC_ARM !== "B") return; // arm A keeps the legacy tier box
    var V3 = window.OSCV3B;
    if (!V3) return; // shared helper missing: render nothing (singles only)

    var cfgEl = root.querySelector("[data-oib-config]");
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var VARIANTS = CFG.variants || [];
    var SIZES = CFG.sizes || [];
    var V3B_TAGS = CFG.v3bBySize || {};
    if (!VARIANTS.length || !SIZES.length) return;

    function money(cents) {
      var n = (cents / 100).toFixed(2);
      return "$" + n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    // <option> can't render <s>, so gift prices are struck with U+0336 overlays.
    function strike(txt) { return String(txt).replace(/[\s\S]/g, "$&\u0336"); }
    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function findVariant(size, color) {
      for (var i = 0; i < VARIANTS.length; i++) {
        if (VARIANTS[i].size === size && VARIANTS[i].color === color) return VARIANTS[i];
      }
      return null;
    }
    function colorsForSize(size) {
      var out = [];
      VARIANTS.forEach(function (v) { if (v.size === size && out.indexOf(v.color) < 0) out.push(v.color); });
      return out;
    }
    function firstAvailableColor(size, preferred) {
      var v = findVariant(size, preferred);
      if (v && v.available) return preferred;
      var cs = colorsForSize(size);
      for (var i = 0; i < cs.length; i++) {
        var w = findVariant(size, cs[i]);
        if (w && w.available) return cs[i];
      }
      return cs[0] || preferred;
    }
    function sizeMinPrice(size) {
      var p = 0;
      VARIANTS.forEach(function (v) { if (v.size === size && (!p || v.price < p)) p = v.price; });
      return p;
    }

    // v3b spec ({pct2, pct4}) for a variant — from ITS size's product tags,
    // scoped by SKU when the tag is scoped. Null = no rungs / no discount.
    function specForVariant(v) {
      if (!v) return null;
      return V3.resolveSpec(V3B_TAGS[v.size] || [], v.sku || "");
    }

    /* ---------- default slot = the size/color the shopper is looking at ---------- */
    function currentSelection() {
      var size = CFG.currentSize && SIZES.indexOf(CFG.currentSize) >= 0 ? CFG.currentSize : SIZES[0];
      var color = null;
      // The legacy PDP's checked swatch is a variant of the current product —
      // its id exists in our aggregated family list.
      var checked = document.querySelector(".colors__input:checked, input[data-color]:checked");
      if (checked) {
        var id = parseInt(checked.value, 10);
        for (var i = 0; i < VARIANTS.length; i++) {
          if (VARIANTS[i].id === id) { size = VARIANTS[i].size; color = VARIANTS[i].color; break; }
        }
      }
      if (!color) color = firstAvailableColor(size, colorsForSize(size)[0]);
      return { size: size, color: color };
    }

    var STATE = { tier: 0, slots: {}, pillowPick: null };

    var elTiers = root.querySelector("[data-oib-tiers]");
    var elMix = root.querySelector("[data-oib-mix]");
    var elSlots = root.querySelector("[data-oib-slots]");
    var elPillowSlots = root.querySelector("[data-oib-pillowslots]");
    var elCta = root.querySelector("[data-oib-cta]");

    function ensureSlots(n) {
      if (!STATE.slots[n]) {
        var cur = currentSelection();
        var arr = [];
        for (var i = 0; i < n; i++) arr.push({ size: cur.size, color: cur.color });
        STATE.slots[n] = arr;
      }
      return STATE.slots[n];
    }
    function curSlots() { return STATE.tier > 0 ? STATE.slots[STATE.tier] || [] : null; }
    function slotVariant(s) { return findVariant(s.size, s.color); }

    /* ---------- pillow gift (1800 only): one free set @7 ---------- */
    var PILLOW = CFG.pillow && CFG.pillow.variants && CFG.pillow.variants.length ? CFG.pillow : null;
    var PILLOW_SIZES = [];
    if (PILLOW) PILLOW.variants.forEach(function (p) { if (PILLOW_SIZES.indexOf(p.size) < 0) PILLOW_SIZES.push(p.size); });
    function pillowVariant(size, color) {
      if (!PILLOW) return null;
      for (var i = 0; i < PILLOW.variants.length; i++) {
        if (PILLOW.variants[i].size === size && PILLOW.variants[i].color === color) return PILLOW.variants[i];
      }
      return null;
    }
    function pillowColors(size) {
      var out = [];
      if (PILLOW) PILLOW.variants.forEach(function (p) { if (p.size === size && out.indexOf(p.color) < 0) out.push(p.color); });
      return out;
    }
    function pillowEarned() { return PILLOW && STATE.tier >= (PILLOW.minUnits || 7); }
    function ensurePillowPick() {
      if (STATE.pillowPick) return STATE.pillowPick;
      if (!PILLOW) return null;
      var size = PILLOW_SIZES.indexOf("Standard") >= 0 ? "Standard" : PILLOW_SIZES[0];
      // Default to a color matching the first set, when available.
      var want = (curSlots() || [{}])[0].color;
      var color = null;
      if (want) {
        pillowColors(size).some(function (c) {
          if (c.toLowerCase().indexOf(String(want).toLowerCase()) >= 0 && pillowVariant(size, c) && pillowVariant(size, c).available) { color = c; return true; }
          return false;
        });
      }
      if (!color) {
        pillowColors(size).some(function (c) {
          var pv = pillowVariant(size, c);
          if (pv && pv.available) { color = c; return true; }
          return false;
        });
      }
      if (!color) color = pillowColors(size)[0];
      return (STATE.pillowPick = { size: size, color: color });
    }
    function pillowPickValue() {
      var p = ensurePillowPick();
      var pv = p && pillowVariant(p.size, p.color);
      return pv ? pv.price : PILLOW ? PILLOW.cents : 0;
    }

    /* ---------- pricing ---------- */
    // v3 percent ladder: group units by identical pct pair, discount within
    // each group (most expensive full price, next inc2 off ITS OWN price,
    // rest incN) — 1:1 with bundle-core.computeV3bDiscount. freeIdx is kept
    // (always empty) so downstream render code stays shared.
    function bundlePrice(slots) {
      var vs = slots.map(slotVariant);
      var sum = 0, was = 0;
      vs.forEach(function (v) {
        sum += v ? v.price : 0;
        was += v ? (v.cmp > v.price ? v.cmp : v.price) : 0;
      });
      var groups = {};
      vs.forEach(function (v) {
        if (!v) return;
        var spec = specForVariant(v);
        if (!spec) return; // un-tagged size: full price, never discounted
        var key = V3.specKey(spec);
        if (!groups[key]) groups[key] = { spec: spec, units: [] };
        groups[key].units.push(v.price);
      });
      var d = 0;
      Object.keys(groups).forEach(function (k) {
        d += V3.groupDiscountCents(groups[k].units, groups[k].spec);
      });
      var total = sum - d;
      return { totalCents: total, wasCents: was > total ? was : 0, freeIdx: [], listCents: sum };
    }

    /* ---------- rung cards (2 / 4 sets, percent ladder) ---------- */
    function renderTiers() {
      if (elMix && elMix.parentNode === elTiers) elTiers.parentNode.insertBefore(elMix, elTiers.nextSibling);
      elTiers.innerHTML = "";
      var cur = currentSelection();
      var curV = findVariant(cur.size, cur.color);
      var spec = specForVariant(curV);
      var l = spec && curV ? V3.ladder(curV.price, spec) : null;
      // No v3b spec (or the 2-rung fails the $25 clamp): singles only — hide
      // the whole component so the PDP behaves like there is no offer.
      if (!l || !l.ok2) {
        root.style.display = "none";
        STATE.tier = 0;
        return;
      }
      root.style.display = "";
      // Rungs mirror the V2 bamboo buybox: an explicit "1 set" card first
      // (selected by default, and the way BACK from 2/4 — clicking it hands
      // purchase flow to the PDP's own single-set ATC), then 2/4.
      var rungs = l.ok4 ? [1, 2, 4] : [1, 2];
      if (STATE.tier && rungs.indexOf(STATE.tier) < 0) STATE.tier = 0;
      rungs.forEach(function (n) {
        var selected = n === 1 ? STATE.tier === 0 : STATE.tier === n;
        var bp, title, sub;
        if (n === 1) {
          title = "1 set";
          sub = money(curV.price).replace(".00", "") + " per set · everyday factory price";
          bp = { totalCents: curV.price, wasCents: curV.cmp > curV.price ? curV.cmp : 0 };
        } else {
          var slots = STATE.tier === n && STATE.slots[n] ? STATE.slots[n] : (function () {
            var arr = [];
            for (var i = 0; i < n; i++) arr.push({ size: cur.size, color: cur.color });
            return arr;
          })();
          bp = bundlePrice(slots);
          title = n + " sets";
          // The badge carries the percent claim and the price column shows
          // per-set cost — the sub keeps only the savings line.
          sub = bp.listCents > bp.totalCents
            ? '<span class="oib-tier-save">You save ' + V3.money(bp.listCents - bp.totalCents) + "</span>"
            : "";
        }
        function pctTxt(p) { return p === 50 ? "\u00BD PRICE" : p + "% OFF"; }
        var badge = "";
        if (n === 2) badge = '<span class="oib-tier-badge">2ND SET ' + pctTxt(l.pct2) + "</span>";
        if (n === 4) badge = '<span class="oib-tier-badge oib-tier-badge--dark">BEST VALUE \u00B7 ' + pctTxt(l.pct4) + " EXTRAS</span>";
        var card = document.createElement("div");
        card.className = "oib-tier" + (selected ? " is-selected" : "");
        card.setAttribute("role", "radio");
        card.setAttribute("aria-checked", selected ? "true" : "false");
        card.innerHTML =
          '<div class="oib-tier-row"><span class="oib-tier-radio" aria-hidden="true"></span><div style="min-width:0;flex:1 1 auto">' +
          '<div class="oib-tier-label">' + title + badge +
          "</div>" +
          '<div class="oib-tier-sub">' + sub + "</div></div>" +
          // Bundles advertise the per-set price ("$65.45 / each") — the full
          // total lives on the CTA; singles keep price + compare-at strike.
          '<div class="oib-tier-prices">' +
          (n === 1
            ? '<div class="oib-tier-price">' + money(bp.totalCents) + "</div>" +
              (bp.wasCents ? '<div class="oib-tier-was">' + money(bp.wasCents) + "</div>" : "")
            : '<div class="oib-tier-price">' + money(Math.round(bp.totalCents / n)) + "</div>" +
              '<div class="oib-tier-each">each</div>') +
          "</div></div>";
        card.addEventListener("click", function () {
          if (n === 1) {
            STATE.tier = 0; // back to singles: mix panel closes, PDP ATC takes over
          } else {
            STATE.tier = n;
            ensureSlots(n);
          }
          renderAll();
        });
        elTiers.appendChild(card);
      });

      // Anchored upgrade line: 0/1 rung context → push the 2nd set; 2 sets
      // selected → push the jump to 4.
      var line = V3.upgradeLine(curV.price, spec, STATE.tier === 0 ? 1 : STATE.tier);
      if (line) {
        var up = document.createElement("div");
        up.className = "oib-v3b-upgrade";
        up.textContent = line;
        elTiers.appendChild(up);
      }
    }

    /* ---------- mix & match panel ---------- */
    function colorDot(size, color, selected, onPick) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "oib-dot" + (selected ? " is-selected" : "");
      var v = findVariant(size, color);
      if (v && v.img) b.style.backgroundImage = 'url("' + v.img + '")';
      b.title = color;
      b.setAttribute("aria-label", color);
      b.addEventListener("click", function () { onPick(color); });
      return b;
    }
    function renderMix() {
      var slots = curSlots();
      if (!slots || !slots.length) { elMix.hidden = true; return; }
      elMix.hidden = false;
      // Dock the panel right under the selected tier card (like the V2 buybox).
      var selCard = elTiers.querySelector(".oib-tier.is-selected");
      if (selCard) selCard.insertAdjacentElement("afterend", elMix);
      var cnt = root.querySelector("[data-oib-mixcount]");
      if (cnt) cnt.textContent = String(STATE.tier);

      var bp = bundlePrice(slots);
      elSlots.innerHTML = "";
      slots.forEach(function (slot, i) {
        var row = document.createElement("div");
        row.className = "oib-slot";
        var isFree = bp.freeIdx.indexOf(i) >= 0;
        var n = document.createElement("span");
        n.className = "oib-slot-n" + (isFree ? " is-free" : "");
        n.textContent = isFree ? "SET " + (i + 1) + " 🎁" : "SET " + (i + 1);
        row.appendChild(n);

        var sel = document.createElement("select");
        SIZES.forEach(function (s) {
          var o = document.createElement("option");
          o.value = s;
          // Price each option as the variant this slot would actually resolve
          // to (its color in size s) — the size's cheapest color can undercut
          // the real price (e.g. a clearance color) and mislead.
          var optCents = sizeMinPrice(s);
          var ov = findVariant(s, firstAvailableColor(s, slot.color));
          if (ov) optCents = ov.price;
          var priceTxt = money(optCents).replace(".00", "");
          o.textContent = isFree ? s + " · " + strike(priceTxt) + " FREE" : s + " · " + priceTxt;
          if (s === slot.size) { o.selected = true; o.setAttribute("selected", ""); }
          sel.appendChild(o);
        });
        sel.addEventListener("change", function () {
          slot.size = sel.value;
          slot.color = firstAvailableColor(slot.size, slot.color);
          renderAll();
        });
        row.appendChild(sel);

        // Color name lives on the top line next to the size select so it sits
        // in the same spot no matter how many swatches wrap below.
        var cname = document.createElement("span");
        cname.className = "oib-slot-color";
        cname.innerHTML = "Color: <b>" + esc(slot.color) + "</b>";
        row.appendChild(cname);

        var note = document.createElement("span");
        note.className = "oib-slot-note";
        var v = slotVariant(slot);
        if (isFree) note.innerHTML = "<s>" + money(v ? v.price : 0) + '</s> <span class="oib-free">FREE</span>';
        else note.textContent = money(v ? v.price : 0);
        row.appendChild(note);

        // Swatches on their own line: only in-stock colors (sold-out ones are
        // hidden, not struck).
        var dots = document.createElement("div");
        dots.className = "oib-dots";
        colorsForSize(slot.size).forEach(function (c) {
          var cv = findVariant(slot.size, c);
          if (!cv || !cv.available) return;
          dots.appendChild(colorDot(slot.size, c, c === slot.color, function (color) {
            slot.color = color;
            renderAll();
          }));
        });
        row.appendChild(dots);
        elSlots.appendChild(row);
      });

      renderPillowRow();

      var save = bp.listCents - bp.totalCents;
      var saveEl = root.querySelector("[data-oib-mixsave]");
      if (saveEl) saveEl.textContent = save > 0 ? "You save " + money(save) + " vs single sets" : "";
      var totEl = root.querySelector("[data-oib-mixtotal]");
      if (totEl) totEl.textContent = "Bundle total " + money(bp.totalCents);
    }
    function renderPillowRow() {
      if (!elPillowSlots) return;
      elPillowSlots.innerHTML = "";
      if (!pillowEarned()) return;
      var pick = ensurePillowPick();
      if (!pick) return;
      var row = document.createElement("div");
      row.className = "oib-slot";
      var n = document.createElement("span");
      n.className = "oib-slot-n is-free oib-slot-n--gift";
      n.textContent = "CASES 🎁";
      row.appendChild(n);

      var sel = document.createElement("select");
      PILLOW_SIZES.forEach(function (s) {
        var o = document.createElement("option");
        o.value = s;
        var minP = 0;
        PILLOW.variants.forEach(function (p) { if (p.size === s && (!minP || p.price < minP)) minP = p.price; });
        o.textContent = s + " pillowcases · " + strike(money(minP || PILLOW.cents)) + " FREE";
        if (s === pick.size) { o.selected = true; o.setAttribute("selected", ""); }
        sel.appendChild(o);
      });
      sel.addEventListener("change", function () {
        pick.size = sel.value;
        if (!pillowVariant(pick.size, pick.color)) {
          var cs = pillowColors(pick.size);
          if (cs.length) pick.color = cs[0];
        }
        renderAll();
      });
      row.appendChild(sel);

      var cname = document.createElement("span");
      cname.className = "oib-slot-color";
      cname.innerHTML = "Color: <b>" + esc(pick.color) + "</b>";
      row.appendChild(cname);

      var note = document.createElement("span");
      note.className = "oib-slot-note";
      note.innerHTML = "<s>" + money(pillowPickValue()) + '</s> <span class="oib-free">FREE</span>';
      row.appendChild(note);

      var dots = document.createElement("div");
      dots.className = "oib-dots";
      pillowColors(pick.size).forEach(function (c) {
        var pv = pillowVariant(pick.size, c);
        if (!pv || !pv.available) return; // hide sold-out gift colors
        var b = document.createElement("button");
        b.type = "button";
        b.title = c;
        b.className = "oib-dot" + (c === pick.color ? " is-selected" : "");
        if (pv.img) b.style.backgroundImage = 'url("' + pv.img + '")';
        b.addEventListener("click", function () { pick.color = c; renderAll(); });
        dots.appendChild(b);
      });
      row.appendChild(dots);
      elPillowSlots.appendChild(row);
    }

    function renderCta() {
      var slots = curSlots();
      if (!slots) return;
      var bp = bundlePrice(slots);
      var prc = root.querySelector("[data-oib-cta-price]");
      if (prc) prc.textContent = money(bp.totalCents);
      var ctaWas = root.querySelector("[data-oib-cta-was]");
      if (ctaWas) {
        var giftsCents = pillowEarned() ? pillowPickValue() : 0;
        var wasBase = bp.wasCents > 0 ? bp.wasCents : bp.listCents;
        var wasTotal = wasBase + giftsCents;
        if (wasTotal > bp.totalCents) {
          ctaWas.hidden = false;
          ctaWas.textContent = money(wasTotal);
        } else {
          ctaWas.hidden = true;
        }
      }
    }

    // Selection that seeded the cached slot arrays. When the shopper changes
    // the PDP's own size dropdown / color swatch, stale slots would otherwise
    // keep pricing the OLD variant (e.g. dropdown says King, slots still
    // Queen) — so reseed every cached tier from the new selection. Edits made
    // inside the mix panel don't touch the top selection and are preserved.
    var seedKey = "";
    function renderAll() {
      var cur = currentSelection();
      var key = cur.size + "|" + cur.color;
      if (key !== seedKey) {
        if (seedKey) {
          STATE.slots = {};
          if (STATE.tier > 0) ensureSlots(STATE.tier);
        }
        seedKey = key;
      }
      renderTiers();
      renderMix();
      renderCta();
    }

    /* ---------- add to cart (same stamping as the guided builder) ---------- */
    var adding = false;
    function addToCart() {
      if (adding) return;
      var slots = curSlots();
      if (!slots || !slots.length) return;
      var bp = bundlePrice(slots);
      var items = [];
      var ok = true;
      slots.forEach(function (slot, i) {
        var v = slotVariant(slot);
        if (!v || !v.available) { ok = false; return; }
        var it = { id: v.id, quantity: 1 };
        if (bp.freeIdx.indexOf(i) >= 0) {
          it.properties = { _osc_bxgy_free: "1", "Free set": "Buy more, get one free — while supplies last" };
        }
        items.push(it);
      });
      if (!ok) { alert("One of your picks just sold out — please choose another color."); return; }
      if (pillowEarned()) {
        var p = ensurePillowPick();
        var pv = p && pillowVariant(p.size, p.color);
        if (pv && pv.available) {
          items.push({ id: pv.id, quantity: 1, properties: { _osc_free_gift: "1", _osc_gift_min: String(PILLOW.minUnits || 7), "Free gift": "With your bundle — while supplies last" } });
        }
      }
      if (!items.length) return;

      adding = true;
      elCta.classList.add("is-adding");
      var lbl = root.querySelector("[data-oib-cta-label]");
      var prev = lbl ? lbl.textContent : "";
      if (lbl) lbl.textContent = "Adding…";
      function done() {
        adding = false;
        elCta.classList.remove("is-adding");
        if (lbl) lbl.textContent = prev;
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () {
          // Same bundles-per-day metric the builder / V2 buybox fire.
          if (window.StoreScaleAB) { try { window.StoreScaleAB.event("bxgy_bundle", "bundle"); } catch (e) {} }
        })
        .then(function () {
          done();
          if (typeof window.getCartData === "function") window.getCartData();
          if (typeof window.toggleSideCart === "function") window.toggleSideCart();
          else if (typeof window.getCartData !== "function") window.location.href = "/cart";
        })
        .catch(function () {
          done();
          alert("Sorry — something went wrong adding to your cart. Please try again.");
        });
    }
    if (elCta) elCta.addEventListener("click", addToCart);

    /* ---------- deep links (?deal=N / ?bundle=N preselects a rung) ---------- */
    try {
      var dqs = new URLSearchParams(location.search);
      var deal = parseInt(dqs.get("deal") || dqs.get("bundle") || "0", 10);
      // v3 mapping: 1→1 (no rung), 2→2, ≥3→4 (covers old deal=3|6|7 links).
      deal = V3.mapPreselect(deal);
      if (deal === 2 || deal === 4) {
        STATE.tier = deal;
        ensureSlots(deal);
        setTimeout(function () {
          if (root.scrollIntoView) root.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);
      }
    } catch (e) {}

    // Keep tier prices in sync when the shopper flips the PDP's own swatches
    // or size dropdown (unopened cards preview with the current selection;
    // renderAll reseeds cached slots when the selection actually changed).
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;
      var isSwatch = t.classList && t.classList.contains("colors__input");
      var isSizeDd = t.hasAttribute && t.hasAttribute("data-size-dropdown");
      if (isSwatch || isSizeDd) renderAll();
    });

    renderAll();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
}());
